import { render } from "./BlockLoading.vue?vue&type=template&id=1199aae1&scoped=true"
const script = {}

import "./BlockLoading.vue?vue&type=style&index=0&id=1199aae1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1199aae1"]])

export default __exports__